import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const WeekHeader = ({ color = 'currentColor', className = null }) => (
    <svg
        // width="662.9px"
        // height="610px"
        viewBox="0 0 662.9 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <g>
            <path fill={color} d="M5.2,0h30.9v87.5h33.3v27.2H5.2V0Z" />
            <path
                fill={color}
                d="M106,0h40.7l32.7,114.7h-33.5l-4.6-19.3h-31.3l-4.6,19.3h-32.1L106,0ZM116.2,68.7h18.8l-9-38.4h-.6l-9.2,38.4Z"
            />
            <path
                fill={color}
                d="M39,174.6l22,13.5c8.1,4.9,17.9,14.4,17.9,31.8s-16.4,34.9-39,34.9S3.1,239.6,0,221.9l26.8-10.6c1.5,5.4,4.6,15.9,13.6,15.9s7.2-3.5,7.2-6.9-1.1-6-6.6-9.3l-18.7-11.5c-7.6-4.7-19-11.3-19-30.6s13.8-33.8,36.4-33.8,33.2,10.6,38.7,28.1l-26.5,9.9c-4.4-9.8-8.9-11.3-12.7-11.3s-5.8,2-5.8,5.4,2.9,5.8,5.5,7.3Z"
            />
            <path
                fill={color}
                d="M94.8,137.6h69.4v26.8h-38.5v17h35.5v26.5h-35.5v17.3h39.3v27.2h-70.2v-114.7Z"
            />
            <path
                fill={color}
                d="M227.7,229.8l-15.8-38.4h-.6v60.9h-29.5v-114.7h37.8l20.5,52.3h.6l22-52.3h35.8v114.7h-29.4v-60.9h-.6l-15.9,38.4h-24.9Z"
            />
            <path
                fill={color}
                d="M341.9,137.6h40.7l32.7,114.7h-33.5l-4.6-19.3h-31.3l-4.6,19.3h-32.1l32.7-114.7ZM352.2,206.3h18.8l-9-38.4h-.6l-9.2,38.4Z"
            />
            <path fill={color} d="M426,137.6h30.9v114.7h-30.9v-114.7Z" />
            <path
                fill={color}
                d="M542.4,252.3l-35.8-59h-.6v59h-29.5v-114.7h31.3l35.2,58.9h.6v-58.9h29.5v114.7h-30.7Z"
            />
            <path
                fill={color}
                d="M592.7,137.6h69.4v26.8h-38.5v17h35.5v26.5h-35.5v17.3h39.3v27.2h-70.2v-114.7Z"
            />
            <path
                fill={color}
                d="M5.2,389.9v-114.7h40.8c33.9,0,59,22.5,59,57.3s-25.1,57.3-59,57.3H5.2ZM73.2,332.4c0-19.4-10.9-30.4-27.2-30.4h-9.8v60.7h9.8c16.4,0,27.2-10.9,27.2-30.3Z"
            />
            <path
                fill={color}
                d="M210.3,347.3c0,26.5-17.4,45.1-45.7,45.1s-45.7-18.7-45.7-45.1v-72h30.9v74.8c0,8.7,6.1,14.8,14.8,14.8s14.8-6.1,14.8-14.8v-74.8h30.9v72Z"
            />
            <path
                fill={color}
                d="M262.4,389.9v-114.7h40.8c33.9,0,59,22.5,59,57.3s-25.1,57.3-59,57.3h-40.8ZM330.4,332.4c0-19.4-10.9-30.4-27.2-30.4h-9.8v60.7h9.8c16.4,0,27.2-10.9,27.2-30.3Z"
            />
            <path
                fill={color}
                d="M372.2,332.6c0-35.3,24-59.8,58.6-59.8s58.7,24.5,58.7,59.8-24,59.8-58.7,59.8-58.6-24.5-58.6-59.8ZM457.8,332.4c0-19.7-9.8-32.1-27.1-32.1s-26.9,12.4-26.9,32.1,9.8,32,26.9,32,27.1-12.1,27.1-32Z"
            />
            <path
                fill={color}
                d="M584.3,314.5c-5.5-9-15.4-14.2-26.5-14.2-16.8,0-26.9,12.4-26.9,32.1s10.1,32,26.9,32,20.8-5.4,26.5-14.1l20.2,18.2c-9.6,15.1-25.5,23.9-46.6,23.9-36.4,0-58.6-24.5-58.6-59.8s24-59.8,58.6-59.8,37.6,9,47.4,24.2l-21,17.6Z"
            />
        </g>
    </svg>
);

WeekHeader.propTypes = propTypes;

export default WeekHeader;
